export default __webpack_public_path__ + "static/media/Aria_Leighty_AHV_In_Moms_We_Trust.d46499d3.jpg";